<div class="modal__main">
    <div class="main__leftpart">
        <div class="leftpart__image leftpart__image_big">
            <img [src]="sharedDataService.assetsCdn('images/dent-and-pony.jpg')" alt="" loading="lazy">
        </div>
    </div>
    <div class="mainRightPartExceptionFlow main__rightpart border-xs-gray">
        <div class="rightpart__header rightpart__header_bg-orange header-xs-smaller font-lg-bigger">We need more information</div>
        <div class="exceptionFlowGroupA flex-column a-items-center m-y-xs-regular m-y-xs-large p-y-lg-big">
            <span class="icon icon_giant icon_support m-b-xs-small m-b-xs-big m-b-lg-medium-big"></span>
            <div style="color: #333333;" class="font-xs-medium font-lg-medium-big p-x-xs-regular">
                Before we can show you loan options, please provide a bit more info.<br>For your security, the info must be submitted via the iCreditWorks App.
            </div>
        </div>
        <div class="modalFooterExceptionFlow modal__footer">
            <div class="footer-text border_bottom">
                <div class="column-lg-90">
                    <span class="font-weight-bold">Click submit</span> and we’ll text you a secure link to download<br> the <span class="font-weight-bold">iCreditWorks App</span> to complete your loan application.</div>
            </div>
            <div class="flex-row j-content-between p-t-medium">
                <!-- <div class="modal__input column-xs-45 column-lg-40 phone-number">
                    <span class="mobPhoneSpan font-color-gray">Mobile #</span>
                    <input id="appLinkInputModal" class="mobile-input" type="text" maxlength="12"  placeholder="555-555-5555" />
                </div> -->
                <div id="appLinkInputModalDiv" *ngIf="!breakpoints.extraSmall" class="modal__input column-xs-45 column-lg-40 phone-number input-area__inactive" (click)='inputItemClick($event)'>
                    <span class="mobPhoneSpan font-color-gray">Mobile #</span>
                    <input [(ngModel)]="mobileNumber" id="appLinkInputModal" mask="000-000-0000" class="mobile-input" type="text" placeholder="" />
                </div>
                <div id="appLinkInputModalDiv" *ngIf="breakpoints.extraSmall" class="modal__input column-xs-45 column-lg-40 phone-number input-area__inactive" (click)='inputItemClick($event)'>
                    <span class="font-color-gray">Mobile #</span>
                    <input [(ngModel)]="mobileNumber" id="appLinkInputModal" mask="000-000-0000" class="mobile-input" type="text" placeholder="" />
                </div>
                <div class="btnSizeNrm btn btn-size_normal btn-white btn-white_animation column-xs-45 column-lg-30" (click)="toSendAppLinkEvent($event)">Submit</div>
            </div>
        </div>
    </div>
</div>